import React, { useEffect, useState } from "react";
import CommonConfiguration from "./components/commonConfigurations/CommonConfiguration";
import SideNav from "./components/SideNav";
import TopNavbar from "./components/TopNavbar";
import WidgetConfiguration from "./components/widgetConfigurations/WidgetConfiguration";
import { getAdminDetails } from "./services/accessService";
import ManageRoles from "./components/darajaOnboarding/ManageRoles";
import AccessMatrix from "./components/accessMatrix/AccessMatrix";
import UserEligibility from "./components/userEligibility/UserEligibility";
import DashboardMonitoring from "./components/dashboardMonitoring/DashboardMonitoring";
import QuickAppsConfig from "./components/quickAppsConfiguration/QuickAppsConfig";
import FeatureNameConfig from "./components/featureNameConfiguration/FeatureNameConfig";
import AccessReport from "./components/accessReport/AccessReport";

interface AdminConfiguration {
  configurationCode: string;
  configurationName: string;
  items: any[];
}

const AccessMatrixContainer: React.FC = () => {
  const [drawerOpen, setDrawerOpen] = useState(true);

  const [configurations, setConfigurations] = useState<
    AdminConfiguration[]
  >([]);
  const widgetConfig = configurations.find((c) => c.configurationCode === "widget.config");
  const commonConfig = configurations.find((c) => c.configurationCode === "common.config");

  const [active, setActive] = useState<string>("");

  const updatedBy = "Admin";

  useEffect(() => {
    loadAdminConfigurations();
  }, []);

  const loadAdminConfigurations = async () => {
    try {
      const response = await getAdminDetails();

      const configs = response?.data || [];

      setConfigurations(configs);

      if (configs.length > 0) {
        setActive(configs[0].configurationCode);
      }
    } catch (error) {
      console.error("Failed to load admin configurations", error);
    }
  };

  const renderContent = () => {
    switch (active) {
      case "onboarding.config":
        return (
          <ManageRoles
            open={true}
            onClose={() => {}}
            createdBy={updatedBy}
          />
        );

      case "access.config":
        return <AccessMatrix />;

      case "widget.config":
        return (
            <WidgetConfiguration
              items={widgetConfig?.items || []}
            />
          );

     case "common.config":
  return (
    <CommonConfiguration
      items={commonConfig?.items || []}
    />
  );

      case "user.config":
        return <UserEligibility />;

      case "dashboardmonitoring.config":
        return <DashboardMonitoring/>

      case "quickapps.config":
        return <QuickAppsConfig/>
      
      case "featurename.config":
        return <FeatureNameConfig/>

      case "accessreport.config":
        return <AccessReport/>

      default:
        return null;
    }
  };

  return (
    <div className="bg-[#f6f4ef] min-h-screen">
      <TopNavbar
        drawerOpen={drawerOpen}
        setDrawerOpen={setDrawerOpen}
      />

      <div className="flex">
       <SideNav
        drawerOpen={drawerOpen}
        active={active}
        setActive={setActive}
        configurations={configurations}
      />

        <div
          className={`flex-1 transition-all duration-500 ${
            drawerOpen ? "ml-[260px]" : "ml-[64px]"
          }`}
        >
          <div className="p-5">
            {renderContent()}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccessMatrixContainer;